import "./AsideMenuComponent.css";
import { BaseAsideMenuComponent } from "../../../shared/components/index/app/BaseAsideMenuComponent";
import { LoginPlataformaResponse } from "../../../shared/response/seguridad/LoginPlataformaResponse";
import template from "./template.html";
import { calcularMenu } from "../../permisosMenu";

const NAV_ROUTES: [string, string][] = [
  ["dashboard",     "/dashboard"],
  ["mis-proyectos", "/proyectos/mis-proyectos"],
  ["clientes",      "/terceros/clientes"],
  ["mapa-fincas",   "/terceros/mapa-fincas"],
  ["promotores",    "/terceros/promotores"],
  ["marketing",     "/marketing/campanas"],
  ["pipeline",  "/ventas/pipeline"],
  ["costos",        "/admin/costos"],
  ["productos-cat", "/admin/catalogos/productos"],
  ["cultivos",      "/admin/catalogos/cultivos"],
  ["usuarios",      "/admin/usuarios"],
  ["hardware",      "/sistema/hardware"],
  ["monitoreo-fenologicos", "/monitoreo/estados-fenologicos"],
  ["monitoreo-plagas",      "/monitoreo/plagas"],
  ["proyectos-dashboard",      "/proyectos/dashboard"],
  ["proyectos-lista",          "/proyectos/proyectos"],
  ["proyectos-catalogo",       "/proyectos/catalogo"],
  ["proyectos-parametros",     "/proyectos/parametros"],
  ["proyectos-tecnicos",       "/proyectos/tecnicos"],
  ["proyectos-nucleos",        "/proyectos/nucleos"],
  ["proyectos-macro",          "/proyectos/macro-proyectos"],
  ["proyectos-cultivos",       "/proyectos/cultivos"],
];

export class AsideMenuComponent extends BaseAsideMenuComponent {
  private _loginResponse: LoginPlataformaResponse;
  private _isSextante: boolean;

  constructor(loginResponse: LoginPlataformaResponse, isSextante: boolean) {
    super();
    this._loginResponse = loginResponse;
    this._isSextante = isSextante;
  }

  protected getTemplateString(): string {
    return template;
  }

  /** Datos de la plantilla: el login y qué opciones del menú se ven (`calcularMenu`). */
  protected getData() {
    return { ...this._loginResponse, ...calcularMenu(this._loginResponse, this._isSextante) };
  }

  /**
   * Conecta cada opción del menú con su ruta, y los grupos acordeón. El clic solo pide la pantalla: la opción la marca
   * `marcarRuta`, que `AppComponent` llama en cada navegación (2026-10-28; antes la marcaba el clic, y los enlaces
   * entre páginas dejaban marcada la anterior).
   */
  protected afterInit(parent: HTMLElement): void {
    for (const [nav, route] of NAV_ROUTES) {
      parent.querySelector<HTMLElement>(`[data-nav="${nav}"]`)?.addEventListener("click", () => this.onPageChange(route));
    }
    this._wireAccordion(parent, "navMonitoreoGroup", "navMonitoreoSub");
    this._wireAccordion(parent, "navProyectosGroup", "navProyectosSub");
  }

  /**
   * Marca la opción del menú de la ruta abierta y, si es una sub-opción, abre su grupo. Si la ruta no tiene opción en
   * el menú (por ejemplo, «Sin permisos»), no deja ninguna marcada.
   */
  public override marcarRuta(route: string): void {
    const nav = NAV_ROUTES.find(([, ruta]) => ruta === route)?.[0];
    if (nav) {
      this.setActivePage(nav);
      return;
    }
    const sidebar = document.getElementById("sideBarNav");
    if (sidebar) this._clearActive(sidebar);
  }

  /** Cablea un grupo de nav como acordeón (toggle open del header + su submenú). */
  private _wireAccordion(parent: HTMLElement, groupId: string, subId: string): void {
    const group = parent.querySelector<HTMLElement>(`#${groupId}`);
    const sub   = parent.querySelector<HTMLElement>(`#${subId}`);
    if (!group || !sub) return;
    group.addEventListener("click", () => {
      const open = group.classList.toggle("open");
      sub.classList.toggle("open", open);
    });
  }

  public setActivePage(nav: string): void {
    const sidebar = document.getElementById("sideBarNav");
    if (!sidebar) return;
    this._clearActive(sidebar);
    const item = sidebar.querySelector<HTMLElement>(`[data-nav="${nav}"]`);
    if (item) {
      item.classList.add("active");
      // Si es una sub-ruta, abrir su grupo acordeón para que quede visible.
      const subGroup = item.closest<HTMLElement>(".nav-sub-group");
      if (subGroup) {
        subGroup.classList.add("open");
        subGroup.previousElementSibling?.classList.add("open");
      }
    }
  }

  private _clearActive(parent: HTMLElement): void {
    parent.querySelectorAll(".nav-item, .nav-sub-item").forEach((el) => el.classList.remove("active"));
  }
}